/**
 * @generated SignedSource<<51d7ce89feeec0fee44f04325024e810>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersRecruitTypeChoices = "EM" | "HP" | "RO" | "WL" | "YP" | "%future added value";
export type UpdateRecruitInput = {
  clientMutationId?: string | null;
  meta: any;
  recruitId: string;
  selectedEmails?: ReadonlyArray<string> | null;
};
export type CommunicationComposePageSaveRecruitEmailMutation$variables = {
  input: UpdateRecruitInput;
};
export type CommunicationComposePageSaveRecruitEmailMutation$data = {
  readonly updateRecruit: {
    readonly recruit: {
      readonly id: string;
      readonly meta: any | null;
      readonly type: ScreenersRecruitTypeChoices | null;
    } | null;
  } | null;
};
export type CommunicationComposePageSaveRecruitEmailMutation = {
  response: CommunicationComposePageSaveRecruitEmailMutation$data;
  variables: CommunicationComposePageSaveRecruitEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateRecruitPayload",
    "kind": "LinkedField",
    "name": "updateRecruit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitNode",
        "kind": "LinkedField",
        "name": "recruit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meta",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunicationComposePageSaveRecruitEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommunicationComposePageSaveRecruitEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4ae9c1c243710995ace574dd459650b9",
    "id": null,
    "metadata": {},
    "name": "CommunicationComposePageSaveRecruitEmailMutation",
    "operationKind": "mutation",
    "text": "mutation CommunicationComposePageSaveRecruitEmailMutation(\n  $input: UpdateRecruitInput!\n) {\n  updateRecruit(input: $input) {\n    recruit {\n      id\n      type\n      meta\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec6c41fb870f1189fc247ed37a9590fb";

export default node;
